<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
      { title: this.$t(`menu.${serviceSlug}`), disabled: true},
      { title: $t('menu.evohealth/anamneses'), disabled: true}
    ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">

      </div>
    </Breadcrumbs>

    <template v-if="isLoading">
      <div class="overlay-loader"></div>
      <LoadingPlaceholder />
    </template>

    <div class="row evollu-form">
      <div class="col-12 col-md-4">
        <div>
          <label class="form-label">{{ $t('facility.inputs.entity') }}:</label>
          <multiselect
            v-model="filters.entity"
            :options="entitiesOptions"
            track-by="id"
            label="name"
            :custom-label="formatedEntityLabel"
            :placeholder="$t('facility.inputs.entity')"
            select-label=""
            selected-label=""
            deselect-label=""
            :allow-empty="false"
            :multiple="false"
            :searchable="true">
            <template slot="clear">
                <span class="multiselect__clear" v-if="filters.entity !== null"
                      @mousedown.prevent.stop="filters.entity = null;"></span>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <div v-if="filters.entity">
      <AnamnesisTable :filters="filters" :allowed-entities="entitiesOptions"/>

    </div>
    <div v-else>
      <div class="no-data-disclaimer">
        <h5> {{ $t('please_select_filter_to_show_data') }} </h5>
      </div>
    </div>
  </div>

</template>
<script>
import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
import LoadingPlaceholder from '@/components/common/LoadingPlaceholder.vue';
import RangeDatePicker from '@/components/common/RangeDatePicker.vue';
import Multiselect from 'vue-multiselect';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import AnamnesisDetails from '@/components/evohealth/anamneses/AnamnesisDetails.vue'
import AnamnesisTable from '@/components/evohealth/anamneses/AnamnesisTable.vue';

export default {
  components: { AnamnesisTable, Multiselect, RangeDatePicker, LoadingPlaceholder, Breadcrumbs, AnamnesisDetails },
  mixins: [MultiselectLabelFormatter],
  props: {
    serviceSlug: {
      type: String,
      required: true,
    },
    component: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      filters: {
        entity: null,
      },

    };
  },
  created() {
  },
  methods: {
  },
  computed: {
    entitiesOptions: function() {
      const permissions = this.component.service.user_permissions.filter(perm => perm.access_type >= 2 && perm.info_type === 110);
      let entities = [];
      if (permissions.some(perm => perm.entity_id === null)) {
        entities = this.component.service.entities;
      } else {
        const entitiesIds = permissions.map(perm => perm.entity_id);
        entities = this.component.service.entities.filter(ent => entitiesIds.includes(ent.id));
      }

      if (entities.length === 1) {
        this.filters.entity = entities[0];
      }

      return entities;
    },
  },
};
</script>

<style scoped lang="scss">
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}

.no-data-disclaimer {
  width: 100%;
  margin-top: 20px;
  border-radius: 12px;
  background-color: rgb(246, 236, 221);
  height: 60px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;

  h5 {
    color: #878787;
  }
}

.outline-border {
  border: 1px solid #dadada;
  border-radius: 15px;
  padding-top: 10px;
  padding-bottom: 20px;
}

.outline-border-answer-options {
  border: 1px solid #dadada;
  border-radius: 15px;
  padding-top: 10px;
  padding-bottom: 20px;
  margin-left: 15px;
  margin-right: 15px;
}

.outline-border {
  margin-bottom: 15px;
}

</style>
